import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import {
  getEventCompletedMilestones,
  getTreasureExpressRewards,
  getUnclaimedMilestones,
  isTreasureExpressAvailable,
} from './treasureExpress.getters';
import { grantMatch2Rewards } from '../match2/match2.modifiers';
import { initializeTreasureExpressEvent } from './treasureExpress.modifiers';
import { Match2Reward } from '../match2/rewards/match2-rewards.ruleset';

export const treasureExpressActions = createActions({
  claimAllTreasureExpressMilestones: action((state, _, api) => {
    // List of all milestones claimed, for the UI to display
    const claimsMade: {
      eventId: string;
      tickets: number;
      milestone: number;
      rewards: Match2Reward[];
    }[] = [];

    // Get unclaimed Milestones
    const unclaimedMilestones = getUnclaimedMilestones(state, api.date.now());

    // Loop through all unclaimed milestones found
    for (const eventId in unclaimedMilestones) {
      // Sanity check if user has entered the event
      const entry = state.treasureExpress?.entries[eventId];
      if (!entry) continue;

      // Retrieve the number of unclaimed milestones for this event
      const unclaimed = unclaimedMilestones[eventId];

      // Claim one by one, so they can be pushed to the results in order
      for (let i = 0; i < unclaimed; i++) {
        // Find out milestones already completed
        const completed = getEventCompletedMilestones(state, eventId);

        // Find the next milestone to claim, from lower to higher
        const milestoneRewardIndex = completed - unclaimed + i;

        // Find out the rewards for this milestone
        const rewards = getTreasureExpressRewards(state, eventId)[
          milestoneRewardIndex
        ];

        // Check if there are any rewards and skip to next iteration if not
        if (!rewards || rewards.length === 0) {
          continue;
        }

        // Increment the claimed milestones
        entry.claimedMilestones += 1;

        // Claim the rewards
        grantMatch2Rewards(
          state,
          rewards,
          {
            feature: 'treasure_express',
            $subFeature: eventId,
          },
          api,
        );

        // Append this claim to the results
        claimsMade.push({
          eventId,
          tickets: entry.tickets,
          milestone: entry.claimedMilestones,
          rewards,
        });
      }
    }

    // Return all claims made - will be empty if no claims were made
    return claimsMade;
  }),

  /**
   * Update the last seen timestamp of the Treasure Event
   */
  updateTreasureExpressLastSeen: action((state, _, api) => {
    // Cannot update if not available
    if (!isTreasureExpressAvailable(state, api.date.now())) return;
    // Update the last seen timestamp
    state.treasureExpress.lastSeenAt = api.date.now();
  }),

  /**
   * Initialize the Treasure Express state
   */
  initializeTreasureExpress: action((state, _, api) => {
    initializeTreasureExpressEvent(state, api.date.now());
  }),
});
